import React, { useState, useEffect } from 'react';
import { ConfigProvider } from 'antd';
import { CustomLoader } from '@components/UI/CustomLoader/Index.jsx';
import { StyledTable } from '@styles/datatables/datatable-antd.js';
import ptBR from 'antd/es/locale/pt_BR';

const GridRelatorioPermissoes = ({ state, setData }) => {
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const fetchData = async (currentPage, currentRowsPerPage) => {
    setLoading(true);
    try {
      const response = await GetAllProcessos(currentPage, currentRowsPerPage);
      setData(response.items, response.totalItems);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(page, rowsPerPage);
  }, [page, rowsPerPage]);

  const handlePageChange = (newPage, newRowsPerPage) => {
    setPage(newPage);
    setRowsPerPage(newRowsPerPage);
  };

  const columns = [
    {
      title: 'NÚMERO',
      dataIndex: 'numSolicitacao',
      key: 'numSolicitacao',
      sorter: (a, b) => a.numSolicitacao - b.numSolicitacao,
      width: '15%',
    },
    {
      title: 'DATA',
      dataIndex: 'data',
      key: 'data',
      sorter: (a, b) => a.data.localeCompare(b.data),
      width: '15%',
    },
    {
      title: 'UNIDADE/GERÊNCIA',
      dataIndex: 'unidade',
      key: 'unidade',
      width: '30%',
      sorter: (a, b) => a.unidade.localeCompare(b.unidade),
    },
    {
      title: 'USUÁRIO',
      dataIndex: 'usuario',
      key: 'usuario',
      width: '20%',
      sorter: (a, b) => a.usuario.localeCompare(b.usuario),
    },
    {
      title: 'PERMISSÕES DO USUÁRIO',
      dataIndex: 'permissoes',
      key: 'permissoes',
      width: '20%',
      sorter: (a, b) => a.permissoes.localeCompare(b.permissoes),
    },
  ];


  return (
    <div className='px-4'>
      <ConfigProvider locale={ptBR}>
        <StyledTable
          title={() => (
            <div>
              <h5 className="mb-0 fw-bold" style={{ color: '#2b97be' }}> Resumo de Permissões </h5>
            </div>
          )}
          columns={columns}
          //dataSource={}
          loading={{
            spinning: loading,
            indicator: <CustomLoader />, // Spinner personalizado
          }}
          pagination={{
            current: page,
            pageSize: rowsPerPage,
            total: state.totalRows,
            onChange: handlePageChange,
            showSizeChanger: true,
            onShowSizeChange: handlePageChange,
            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`, // Exibe o total de registro
          }}
          scroll={{ y: '20rem', x: 'max-content' }}
          locale={{ emptyText: <h2 className='m-3'>Nenhum resumo de permissões disponível para exibição.</h2> }}
        />
      </ConfigProvider>
    </div>
  );
};

export default GridRelatorioPermissoes;